import { render, staticRenderFns } from "./exhibitionHallDetails.vue?vue&type=template&id=7e484254&scoped=true"
import script from "./exhibitionHallDetails.vue?vue&type=script&lang=js"
export * from "./exhibitionHallDetails.vue?vue&type=script&lang=js"
import style0 from "./exhibitionHallDetails.vue?vue&type=style&index=0&id=7e484254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e484254",
  null
  
)

export default component.exports